const ReactivateUserKeys = {
    TITLE: "title",
    USER_ID: "userId",
    SUBMIT_BUTTON: "submitButton",
    SUCCESS_MESSAGE: "successMessage",
    ERROR_MESSAGE: "errorMessage",
    ERROR_MESSAGE_EMPTY_USER_ID: "errorMessageEmptyUserId",
    Validations: {
        ERROR_MSG_MAX_LENGTH: "validations.errMsgMaxLength"
    }
}

export default ReactivateUserKeys
